<template>
  <el-dialog :title="$t('mainCategory.editCategory')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="editMainCategoryInfo" :rules="rules" label-width="120px">
      <el-form-item :label="$t('mainCategory.categoryName')" prop="categoryName">
        <el-input v-model="editMainCategoryInfo.categoryName" :placeholder="$t('mainCategory.inputCategoryName')" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.startTime')" prop="startTime">
        <el-date-picker 
          v-model="editMainCategoryInfo.startTime" 
          type="datetime"
          :placeholder="$t('mainCategory.selectStartTime')" 
          value-format="yyyy-MM-dd HH:mm:ss" 
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%" 
        />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.endTime')" prop="endTime">
        <el-date-picker 
          v-model="editMainCategoryInfo.endTime" 
          type="datetime"
          :placeholder="$t('mainCategory.selectEndTime')" 
          value-format="yyyy-MM-dd HH:mm:ss" 
          format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%" 
        />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.seq')" prop="seq">
        <el-input v-model.number="editMainCategoryInfo.seq" :placeholder="$t('mainCategory.inputSeq')" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.desc')" prop="categoryDesc">
        <el-input v-model="editMainCategoryInfo.categoryDesc" type="textarea"
          :placeholder="$t('mainCategory.inputDesc')" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="editMainCategory">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateMainCategory } from '@/api/admin/mainCategory/mainCategoryApi'

export default {
  name: 'EditMainCategory',
  data() {
    return {
      dialogVisible: false,
      editMainCategoryInfo: {
        mainCategoryId: '',
        categoryName: '',
        startTime: '',
        endTime: '',
        seq: '',
        categoryDesc: ''
      },
      rules: {
        categoryName: [
          { required: true, message: this.$t('mainCategory.categoryNameRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('mainCategory.categoryNameTooLong'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('mainCategory.startTimeRequired'), trigger: 'change' }
        ],
        endTime: [
          { required: true, message: this.$t('mainCategory.endTimeRequired'), trigger: 'change' }
        ],
        seq: [
          { required: true, message: this.$t('mainCategory.seqRequired'), trigger: 'blur' }
        ],
        categoryDesc: [
          { required: true, message: this.$t('mainCategory.descRequired'), trigger: 'blur' },
          { max: 512, message: this.$t('mainCategory.descTooLong'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      // 保持原有的简单处理方式，只在出错时进行修复
      //this.editMainCategoryInfo = { ...data }
      Object.assign(this.editMainCategoryInfo, data)
      console.log(this.editMainCategoryInfo)
      this.dialogVisible = true
      
 
    },
    
    handleClose() {
      this.$refs.form.resetFields()
      // 确保日期字段被正确重置
      this.editMainCategoryInfo = {
        mainCategoryId: '',
        categoryName: '',
        startTime: '',
        endTime: '',
        seq: '',
        categoryDesc: ''
      }
    },
    async editMainCategory() {
      try {
        await this.$refs.form.validate()
        await updateMainCategory(this.editMainCategoryInfo)
        this.$message.success(this.$t('mainCategory.editSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>